import { VERDE_CLARO, VERDE_ESCURO, VERDE, PERIGO_CL, PERIGO, INFO_CL, INFO, ALERTA_CL, ALERTA, RAIO, ESP } from "../tema";
import Icone from "./Icone";

// Faixa de recado: o que deu certo, o que falhou, o que está em curso.
//
// O ícone deixou de ser emoji. Além de mudar de desenho conforme o
// aparelho, o emoji vinha sempre com a cor dele e nunca com a da faixa, e
// o verde do ✅ brigava com o verde do fundo em vez de acompanhá-lo.
export default function StatusBox({ tipo, msg }) {
  const cores = {
    ok: { bg: VERDE_CLARO, cor: VERDE_ESCURO, borda: VERDE, icone: "check" },
    erro: { bg: PERIGO_CL, cor: PERIGO, borda: PERIGO, icone: "alvo" },
    info: { bg: INFO_CL, cor: INFO, borda: INFO, icone: "relogio" },
    aviso: { bg: ALERTA_CL, cor: "#92400E", borda: ALERTA, icone: "pulso" },
  };
  const c = cores[tipo] || cores.info;
  return (
    <div style={{
      display: "flex", alignItems: "flex-start", gap: ESP.md,
      padding: "13px 16px", borderRadius: RAIO.md,
      fontSize: 13.5, fontWeight: 500, lineHeight: 1.55,
      background: c.bg, color: c.cor, border: `1px solid ${c.borda}33`,
      whiteSpace: "pre-line",
    }}>
      <span style={{ flexShrink: 0, marginTop: 1 }}><Icone nome={c.icone} tamanho={17} /></span>
      <span style={{ minWidth: 0 }}>{msg}</span>
    </div>
  );
}
